// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-form-components-AutocompleteSelect-AutocompleteSelect-module__root"};